import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VImg,{staticClass:"workspace-image",attrs:{"height":"40","width":"40","src":_vm.spaceIconStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }